import React from 'react';

interface WristRestProps {}

export function WristRest(props: Readonly<WristRestProps>) {
	return (
		<svg width={90} height={60} viewBox="0 0 90 60" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_2182_18828)">
				<path d="M38.008 44.809c7.248 0 9.478 2.83 9.478 2.83H27.971s2.788-2.83 10.037-2.83z" fill="#71828F" />
				<path
					stroke="#71828F"
					strokeLinecap="round"
					d="M-26.113 47.64H27.97m0 0h19.515s-2.23-2.831-9.478-2.831c-7.249 0-10.037 2.83-10.037 2.83z"
				/>
				<path
					fill="#445662"
					d="M84.29 49.055H50.32S51.514 32.07 66.958 32.07c15.444 0 17.331 16.985 17.331 16.985z"
				/>
				<path
					fill="#999"
					d="M68.865 25.8c.437.2 8.942 3.734 9.638 6.151-.125 2.836-2.669 3.554-3.325 3.908-1.973 1.064-9.036-1.83-12.178-.789 0 0-1.91.696-4.262 1.476-2.353.78-4.473 1.386-4.473 1.386-3.13 1.427-9.903 5.32-9.903 5.32-2.246 1.248-3.058 1.53-4.142 1.732-2.731.513-6.675.155-7.254-.04 0 0-1.464-.362-2.644-1.598 0 0-1.354-2.062-1.818-3.673-.463-1.611.569-3.953.569-3.953.507-.904 3.367-4.503 4.559-5.807 1.192-1.303 4.651-3.428 4.859-3.458 0 0 2.01-1.235 5.111-2.788 1.881-.663 3.96-2.882 3.96-2.882 1.219-1.228 2.355-1.522 2.355-1.522 2.028-.7 3.448-.265 5.13.891 1.661 1.005 5.439 1.343 7.219 2.245 1.777.902 6.163 3.199 6.6 3.4z"
				/>
				<path
					fill="#999"
					d="M45.176 31.34c.999 1.678 1.258 3.28 1.033 5.28-.225 2-.964 4.224-2.233 5.39-.88.808-2.536 1.76-3.989 2.324-3.248 1.26-8.692 1.234-10.801.958-25.12-3.28-23.26-3.688-31.983-5.071-14.537-2.304-31.005-5.491-33.048-6.42-2.044-.93-5.364-3.446-6.43-4.74-1.067-1.293-3.672-4.857-3.554-7.897.118-3.04 1.001-5.382 2.578-7.97 1.576-2.588 4.016-3.85 5.827-4.306 2.174-.547 5.693-.209 8.345.207 8.4 1.44 16.506 3.944 24.697 7.11 6.493 2.6 9.113 4.777 15.695 7.34A70.68 70.68 0 0034.286 27.8c1.85-.072 4.39.281 5.628.474 1.238.194 4.316 1.476 5.262 3.066z"
				/>
				<path d="M-17.621 48.625h141.538" stroke="#BEC4CB" strokeWidth={2} strokeLinecap="round" />
			</g>
			<defs>
				<clipPath id="clip0_2182_18828">
					<path fill="#fff" d="M0 0H90V60H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
